<div class = "confirmationPopup">  
    <div mat-dialog-content>
        <div class="mat-card-header-text confirmHeader" i18n>Confirm Schema Update</div>
        <p class="confirmQuestion" i18n>
            Initiating the update schema will recreate/update all csmobile tables. Existing data in the table will be lost. Are you sure you want to proceed?
        </p>
        <div mat-dialog-actions>
            <div class="confirmButton">      
                <button mat-raised-button type="button" tabindex="-1" class="mat-focus-indicator mat-raised-button mat-button-base mat-primary" color="primary" (click)="confirmRefreshSchema()" i18n>CONFIRM</button>               
            </div> 
        </div>
    </div>   
</div>  